import React from 'react';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient'
import ProviderContactsInfo from './ProviderContactsInfo';
import ProviderMainInfo from './ProviderMainInfo';
import ProviderWorkshopsInfo from './ProviderWorkshopsInfo';
import {
  GET_PROVIDER_WORKSHOP,
  GET_PROVIDER,
} from 'constants/backend_routes'


@inject('providerStore')
@observer
export default class ProviderBio extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      provider: this.props.providerStore.setInitialState()
    }
  }

  componentWillMount(){
    this.initialState(this.props.location);
    this.listener = this.props.history.listen( () => {
      this.initialState();
    });
  }

  initialState = () => {
    let id = this.props.match.params.id;
    new HttpClient().get(GET_PROVIDER + id).then(response => {
      this.setState({
        provider :  response.body.provider
      });
    });

  };


  render(){
    return(
      <main className="main-content purchased">
        <div className="provider-bio container-fluid">
          <div className="row">
            <ProviderContactsInfo provider={this.state.provider}/>
            <ProviderMainInfo provider={this.state.provider}/>
            <ProviderWorkshopsInfo provider={this.state.provider}/>
          </div>
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/provider/ProviderBio.jsx